export function verifyNewRelicTrackingLoaded() {
  if (typeof window.newrelic === "undefined") {
    return false;
  }
  return !!window.newrelic;
}
